import BookingsTab from "./BookingsTab";
import StudentsPassesTab from "./StudentsPassesTab";
import { useAdminApi } from "../adminUtils";

export default function BookingsStudentsTab() {
  const { IS_OWNER } = useAdminApi();
  return (
    <>
      <BookingsTab />
      {IS_OWNER && <StudentsPassesTab />}
    </>
  );
}
